import { motion } from "framer-motion";
import { SITE } from "@/data/site";
import { Overline } from "@/components/shared/Primitives";
import { PrimaryCTA } from "@/components/shared/CTA";
import { reveal, VIEW_ONCE } from "@/components/shared/motion";
import { track, EVENTS } from "@/lib/analytics";

export default function FinalCTA({ from = "page" }) {
  return (
    <section
      id="vision"
      data-testid="final-cta-section"
      className="relative z-10 overflow-hidden border-t border-white/10 px-6 py-32 md:px-16 md:py-40 lg:px-24"
    >
      <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[60vw] -translate-x-1/2 rounded-full bg-[#8B5CF6]/15 blur-[120px]" />
      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="show"
        viewport={VIEW_ONCE}
        className="relative"
      >
        <Overline className="mb-6">Next</Overline>
        <h2 className="font-display max-w-4xl text-4xl font-bold uppercase leading-[1.05] text-[#F4F6FB] md:text-6xl">
          What should{" "}
          <span className="bg-gradient-to-r from-[#8B5CF6] to-[#06B6D4] bg-clip-text text-transparent">
            exist next?
          </span>
        </h2>
        <p className="mt-8 max-w-xl text-sm leading-relaxed text-[#F4F6FB]/60 md:text-base">
          Have an idea that doesn't fit the usual brief?
        </p>
        <div className="mt-12 flex flex-wrap items-center gap-6">
          <PrimaryCTA
            to="/start-a-project"
            testId="final-cta-start-project"
            onClick={() => track(EVENTS.START_PROJECT_CLICK, { from })}
          >
            Start a Project
          </PrimaryCTA>
          <a
            href={`mailto:${SITE.email}`}
            data-testid="final-cta-email"
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#F4F6FB]/50 transition-colors duration-300 hover:text-[#06B6D4]"
          >
            {SITE.email}
          </a>
        </div>
      </motion.div>
    </section>
  );
}
